import { SubjectAreaNames } from '../../interfaces/EOAInterface';

export type CourseMappingSubjectAreaTagVariant =
  | 'science'
  | 'mathematics'
  | 'other-electives'
  | 'world-language'
  | 'english'
  | 'social-studies'
  | 'visual-performing-arts'
  | 'default';

const SUBJECT_AREA_VARIANTS: Record<SubjectAreaNames, CourseMappingSubjectAreaTagVariant> = {
  English: 'english',
  Mathematics: 'mathematics',
  Science: 'science',
  'Social Studies and History': 'social-studies',
  'World Language': 'world-language',
  'Visual/Performing Arts': 'visual-performing-arts',
  'Other Electives': 'other-electives',
};

export const isEmptyCellValue = (value: string | null | undefined): boolean => value == null || value.trim() === '';

export const getSubjectAreaTagVariant = (subjectArea: string): CourseMappingSubjectAreaTagVariant =>
  SUBJECT_AREA_VARIANTS[subjectArea as SubjectAreaNames] ?? 'default';

export const getSelectTagClassName = (columnKey: string, label: string): string => {
  if (columnKey === 'subjectArea') {
    return `course-mapping-select-tag--subject-area-${getSubjectAreaTagVariant(label)}`;
  }

  return 'course-mapping-select-tag--bordered';
};

export const formatCredits = (credits: number | null | undefined): string | null => {
  if (credits == null) return null;
  return credits.toFixed(1);
};

export const formatLanguageLevel = (level: number | null | undefined): string | null => {
  if (level == null) return null;
  if (level >= 4) return '4+';
  return String(level);
};
